import { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { validateViewName } from "../../config/validateViewName";
import "../../lists/ListRowActions.scss";
import { CheckIcon, CrossIcon } from "../../icons";
import { SavedViewNameEditorProps } from "./SavedViewNameEditor.types";

const ActionClasses = "list-row-action";

/** A saved view's name edited in its row: Enter or the tick applies, Escape or the cross cancels. */
export function SavedViewNameEditor({
  name,
  isSaving,
  onApply,
  onCancel,
}: SavedViewNameEditorProps) {
  const [draft, setDraft] = useState(name);
  const input = useRef<HTMLInputElement>(null);
  const problem = validateViewName(draft, []);

  useEffect(() => {
    input.current?.select();
  }, []);

  const apply = () => {
    if (!problem && !isSaving) {
      onApply(draft.trim());
    }
  };

  return (
    <div
      className="flex-grow-1 d-flex align-items-center gap-2"
      style={{ paddingLeft: "calc(1em + 1rem)" }}
    >
      <input
        ref={input}
        type="text"
        aria-label="Saved view name"
        aria-invalid={problem ? true : undefined}
        className="form-control form-control-sm"
        value={draft}
        disabled={isSaving}
        onChange={(event) => setDraft(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            event.preventDefault();
            apply();
          }

          if (event.key === "Escape") {
            event.preventDefault();
            onCancel();
          }
        }}
      />
      <button
        type="button"
        aria-label="Apply name"
        title="Apply (Enter)"
        disabled={Boolean(problem) || isSaving}
        className={classNames(ActionClasses, "text-success")}
        onClick={apply}
      >
        <FontAwesomeIcon icon={CheckIcon} />
      </button>
      <button
        type="button"
        aria-label="Cancel rename"
        title="Cancel (Esc)"
        disabled={isSaving}
        className={classNames(ActionClasses, "text-danger")}
        onClick={onCancel}
      >
        <FontAwesomeIcon icon={CrossIcon} />
      </button>
    </div>
  );
}
